/** Maps pathname patterns to i18n seo keys and indexing rules. */
export const NOINDEX_PREFIXES = ["/app", "/login", "/signup", "/patient"]

export const PUBLIC_ROUTES = [
  "/",
  "/features",
  "/pricing",
  "/integrations",
  "/changelog",
  "/about",
  "/customers",
  "/careers",
  "/press",
  "/help",
  "/blog",
  "/community",
  "/contact",
  "/security",
  "/legal/privacy",
  "/legal/terms",
  "/legal/gdpr",
]

export function getSeoKey(pathname) {
  if (pathname === "/") return "home"
  if (pathname === "/book" || pathname.startsWith("/book/")) return "book"
  if (pathname === "/patient") return "patientPortal"
  if (pathname.startsWith("/pay/")) return "payInvoice"
  if (pathname === "/features") return "features"
  if (pathname === "/pricing") return "pricing"
  if (pathname === "/integrations") return "integrations"
  if (pathname === "/changelog") return "changelog"
  if (pathname === "/about") return "about"
  if (pathname === "/customers") return "customers"
  if (pathname === "/careers") return "careers"
  if (pathname === "/press") return "press"
  if (pathname === "/help") return "help"
  if (pathname === "/blog") return "blog"
  if (pathname === "/community") return "community"
  if (pathname === "/contact") return "contact"
  if (pathname === "/security") return "security"
  if (pathname === "/legal/privacy") return "legalPrivacy"
  if (pathname === "/legal/terms") return "legalTerms"
  if (pathname === "/legal/gdpr") return "legalGdpr"
  if (pathname.startsWith("/blog/")) return "blogPost"
  if (pathname === "/404") return "notFound"
  return "home"
}

export function shouldNoindex(pathname) {
  if (pathname === "/book" || pathname.startsWith("/book/")) return true
  if (pathname.startsWith("/pay/")) return true
  return NOINDEX_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))
}
